/** @jsx jsx */

import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useLayoutEffect,
  Fragment as _,
  useContext,
} from 'react';

import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import getBlockById from 'services/apiHelpers/getBlockById';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import { colors, getButtonFocus } from 'styles/variables';

const TermsAndConditions = ({ size = 15, onClick = null, ...props }) => {
  const context: any = useContext(interactionContext);
  const { id } = props;

  const {
    accept,
    acceptContent = 'e.g. I accept these terms and conditions.',
    acceptBorderRadius = 0,
    acceptTextColor = undefined,
    acceptBackgroundColor = undefined,
    lockDown,
  } = context.props;

  //
  const [toggle, setToggle] = useState(lockDown === 0 ? true : false);

  const tickColor = acceptTextColor || '#000';

  useEffect(() => {
    if (toggle) {
      setBlockProps(getBlockById(context.id), { lockDown: 0 });
    }
  }, [toggle]);

  return accept ? (
    <form onSubmit={e => e.preventDefault()}>
      <div
        css={css`
          position: relative;
          display: inline-flex;
          align-items: center;
          margin: 20px 0 0 0;
          padding: ${acceptBackgroundColor ? '10px' : '10px 0 10px 0'};
          border-radius: ${acceptBorderRadius}px;
          background: ${acceptBackgroundColor};
          cursor: pointer;
          ${(window.dev() || toggle) && 'pointer-events: none;'}

          &:focus {
            // padding: 10px;
            ${getButtonFocus(acceptBackgroundColor || tickColor)}
          }
        `}
        onClick={() => {
          setToggle(true);
        }}
        onKeyUp={
          window.dev()
            ? null
            : (e: any) => {
                console.log(e);
                if ([' ', 'Enter'].includes(e.key)) {
                  setToggle(true);
                }
              }
        }
        tabIndex={!toggle ? 0 : -1}
      >
        <input
          id={`i${id}`}
          type="checkbox"
          value={`i${id}`}
          name={`i${id}`}
          checked={toggle}
          readOnly
          css={css`
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
          `}
          tabIndex={-1}
        />
        <label
          htmlFor={`i${id}`}
          css={css`
            color: ${acceptTextColor};
            pointer-events: none;
          `}
          tabIndex={-1}
        >
          {acceptContent}
        </label>

        <div
          css={css`
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: ${size}px;
            height: ${size}px;
            margin: 0 0 0 10px;
            padding: 2px;
            border: 1px solid ${acceptTextColor || 'lightGrey'};
          `}
        >
          <i
            className="fa fa-check"
            css={css`
              color: ${window.dev() || toggle ? tickColor : 'rgba(0, 0, 0, 0)'};
              font-size: 9px;
            `}
          />
        </div>
      </div>
    </form>
  ) : null;
};

export default TermsAndConditions;
